import {
  EventOrder,
  Product,
  RecipeHardGood,
  RecipeTemplate,
  Stem,
  SupplierStem,
  UnitProduct
} from 'src/common/common.interface'
import { PhotosNeeded } from 'src/common/enum'
import { postHttp } from './apiLayer'
import { QuantityMode } from './recipes'

export interface IStemOfEventOrder {
  stemId: number
  recipeStemId: number
  supplierStemId?: number
  quantity: number
  stem?: Stem
  supplierStem?: SupplierStem
  stemRole?: string
  roleIndex?: number
  sequenceNum?: number
}

export interface IProductOfEventOrder extends Product {
  id: number
  name: string
  recipeId: number
  unitProductPrice: number
  quantity: number
  styleNotes: string
  stems: IStemOfEventOrder[]
  recipeTemplate?: RecipeTemplate
  recipeHardGoods: RecipeHardGood[]
  prepTimeMinutes?: number
  designTimeMinutes?: number
  installTimeMinutes?: number
  loadingTimeMinutes?: number
  photosNeeded?: PhotosNeeded[]
  quantityMode?: QuantityMode
  unitProduct: UnitProduct | null
}

export interface EventOrderResponse {
  eventOrderId: number
  eventOrder: EventOrder
  lastSyncedDate?: string
  products: IProductOfEventOrder[]
}

export const postOrders = async (eventId: number): Promise<EventOrderResponse> => {
  const result = await postHttp(`/eventOrders`, {
    eventId
  })
  return result.data
}
